module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "edit-game-properties"
    }
  }, [_c('div', {
    staticClass: "edit-container"
  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('h1', [_vm._v("Game Details")]), _vm._v(" "), _c('div', {
    staticClass: "edit-platforms"
  }, [_c('label', {
    staticClass: "toggleable",
    on: {
      "click": _vm.togglePlatforms
    }
  }, [_vm._v("\n                    Platform\n                    "), (_vm.platformsOpen) ? _c('i', {
    staticClass: "fas fa-chevron-circle-up"
  }) : _vm._e(), _vm._v(" "), (!_vm.platformsOpen) ? _c('i', {
    staticClass: "fas fa-chevron-circle-down"
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.platforms), function(category) {
    return (_vm.platformsOpen) ? _c('div', {
      staticClass: "platform-group"
    }, [_c('h3', [_vm._v(_vm._s(category.label))]), _vm._v(" "), _c('div', {
      staticClass: "options"
    }, _vm._l((category.platforms), function(platform) {
      return _c('label', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!platform.initiallyHidden || category.showHidden),
          expression: "!platform.initiallyHidden || category.showHidden"
        }]
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (platform.checked),
          expression: "platform.checked"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(platform.checked) ? _vm._i(platform.checked, null) > -1 : (platform.checked)
        },
        on: {
          "change": _vm.clearErrorMessage,
          "__c": function($event) {
            var $$a = platform.checked,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (platform.checked = $$a.concat($$v))
              } else {
                $$i > -1 && (platform.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              platform.checked = $$c
            }
          }
        }
      }), _c('span', [_vm._v(_vm._s(platform.label))])])
    })), _vm._v(" "), _c('span', {
      staticClass: "show-all"
    }, [(!category.showHidden && category.hasHidden) ? _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showHidden(category)
        }
      }
    }, [_vm._v("Show All " + _vm._s(category.label))]) : _vm._e()])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "edit-genres"
  }, [_c('label', {
    staticClass: "toggleable",
    on: {
      "click": _vm.toggleGenres
    }
  }, [_vm._v("\n                    Genre\n                    "), (_vm.genresOpen) ? _c('i', {
    staticClass: "fas fa-chevron-circle-up"
  }) : _vm._e(), _vm._v(" "), (!_vm.genresOpen) ? _c('i', {
    staticClass: "fas fa-chevron-circle-down"
  }) : _vm._e()]), _vm._v(" "), (_vm.genresOpen) ? _c('div', {
    staticClass: "options"
  }, _vm._l((_vm.genres), function(genre) {
    return _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (genre.checked),
        expression: "genre.checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(genre.checked) ? _vm._i(genre.checked, null) > -1 : (genre.checked)
      },
      on: {
        "change": _vm.clearErrorMessage,
        "__c": function($event) {
          var $$a = genre.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (genre.checked = $$a.concat($$v))
            } else {
              $$i > -1 && (genre.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            genre.checked = $$c
          }
        }
      }
    }), _c('span', [_vm._v(_vm._s(genre.label))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "edit-rated"
  }, [_c('label', [_vm._v("Rated")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating),
      expression: "rating"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rating = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "everyone"
    }
  }, [_vm._v("Everyone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "teen"
    }
  }, [_vm._v("Teen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mature"
    }
  }, [_vm._v("Mature")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "adult"
    }
  }, [_vm._v("Adult")])])]), _vm._v(" "), _c('div', {
    staticClass: "edit-release-date"
  }, [_c('label', [_vm._v("Release Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.releaseDate),
      expression: "releaseDate"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.releaseDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.releaseDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "edit-rated"
  }, [_c('label', [_vm._v("Dev Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devStatus),
      expression: "devStatus"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.devStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "indevelopment"
    }
  }, [_vm._v("In Development")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "abandoned"
    }
  }, [_vm._v("Abandoned")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "completed"
    }
  }, [_vm._v("Completed")])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "companion-content-subsection buttons"
  }, [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveChanges($event)
      }
    }
  }, [_vm._v("Save")])])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8bacb072!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/Widgets/EditGameWidget.vue
// module id = 901
// module chunks = 2